module.exports = __webpack_public_path__ + "media/img/Landing_Page/m_and_w_videocall-dc50280da9ed11ffa81cf3740f75da75.jpg";